// @flow
import React from 'react';

type Value = number;

type Position = 'start' | 'middle' | 'end';

type Extreme = {
  position: Position,
  text: string,
};

type Props = {
  extremes: Array<Extreme>,
  title: string,
  value: Value, // Should be a percentage
};

// The width needs to be stored here rather than in CSS, so we can take the width into consideration when positioning.
// Another option is to use React Measure, but that approach seemed overkill in my opinion.
const METER_WIDTH = 0.75;

const ORDER = ['start', 'middle', 'end'];

/**
 * @param {Integer} value - %
 * @return {String} - percentage offset by the meter width
 */
const getPosition = value => `calc(${value}% - ${METER_WIDTH / 2}rem)`;

/**
 * Sort comparison function that compares the position of a label
 * @param {Object} a
 * @param {Object} b
 * @return {number}
 */
const byOrder = (a: Extreme, b: Extreme): number =>
  ORDER.indexOf(a.position) - ORDER.indexOf(b.position);

/**
 * @param {Object} props
 *
 * @return {*}
 * @constructor
 */
const Meter = ({ extremes = [], title, value }: Props) => (
  <p className="c-meter" data-value={value} data-title={title}>
    {title && <span className="c-meter__title">{title}</span>}
    <span className="c-meter__bar">
      <span className="c-meter__value">
        <span
          className="c-meter__value-fill"
          style={{ left: getPosition(value) }}
        />
        <span className="c-meter__ruler" />
      </span>
      {Array.isArray(extremes) && extremes.length && (
        <span className="c-meter__extremes">
          {extremes.sort(byOrder).map(({ position, text }) => (
            <span
              key={position}
              className={`c-meter__extreme c-meter__extreme--${position}`}
            >
              {text}
            </span>
          ))}
        </span>
      )}
    </span>
  </p>
);

export default Meter;
